import { createSlice } from "@reduxjs/toolkit";

export const companySlice = createSlice({
  name: "company",
  initialState: {
    name: "Rajutan Sari Asa",
    tagline: "Kerajinan Rajutan Handmade Berkualitas dari Bali",
    owner: "Ibu Luh Yasa",
    yearEstablished: "2022",
    description:
      "UMKM Rajut Sari Asa adalah usaha kerajinan rajutan handmade yang berlokasi di Desa Padangbulia, Kecamatan Sukasada, Kabupaten Buleleng, Bali. Hadir sejak tahun 2022 dengan produk rajutan berkualitas tinggi dan motif menarik yang dikerjakan secara handmade dengan ketelitian dan penuh cinta di setiap prosesnya.",
    mission:
      "Menghadirkan produk kerajinan rajutan handmade berkualitas tinggi dengan harga terjangkau, serta memberdayakan penyandang disabilitas melalui keterampilan merajut",
    vision:
      "Menjadi UMKM kerajinan rajutan terdepan di Bali yang dikenal menghasilkan produk handmade berkualitas ekspor",
    address:
      "Desa Padangbulia, Kecamatan Sukasada, Kabupaten Buleleng, Provinsi Bali",
    license: "12121220071353 (Usaha Mikro)",
    employees: "2 orang",
  },
  reducers: {},
});
